import { useLocalStorageState } from "ahooks";

import CloseIcon from "@mui/icons-material/Close";
import TableRowsRoundedIcon from "@mui/icons-material/TableRowsRounded";
import ViewHeadlineIcon from "@mui/icons-material/ViewHeadline";
// import ViewWeekOutlinedIcon from "@mui/icons-material/ViewWeekOutlined";
import {
  ClickAwayListener,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  Typography,
} from "@mui/material";

// import { setUserPreference } from "@/api/account";
import { ListViewType } from "@/constants";
import useEvent from "@/hooks/useEvent";

interface ViewTypeProps {
  value?: number;
  onChange: (v: number) => void;
}
const ViewType = (props: ViewTypeProps) => {
  const [tooltipIdentifyVisible, setTooltipIdentifyVisible] = useLocalStorageState(
    "__panoramaViewTypeTooltipIdentify__",
    {
      defaultValue: true,
    }
  );
  const hideTooltip = useEvent(() => {
    setTooltipIdentifyVisible(false);
  });

  // const { loading, runAsync } = useRequest(
  //   (v: number) =>
  //     setUserPreference({
  //       real_time_search_table_type: v,
  //     }),
  //   {
  //     manual: true,
  //   }
  // );
  return (
    <ClickAwayListener onClickAway={() => 0}>
      <Tooltip
        placement="right"
        title={
          <div className="flex items-center">
            <Typography color={"primary"} fontWeight={700} fontSize={14} className="mr-[4px]">
              try different layouts!
            </Typography>
            <CloseIcon fontSize="small" onClick={hideTooltip} className="cursor-pointer ml-[4px]" />
          </div>
        }
        arrow
        PopperProps={{
          sx: {
            zIndex: -100,
          },
        }}
        componentsProps={{
          tooltip: {
            sx: {
              paddingX: "8px",
              paddingLeft: "15px",
              paddingY: "2px",
            },
          },
        }}
        onClose={hideTooltip}
        open={tooltipIdentifyVisible}
        disableFocusListener
        disableHoverListener
        disableTouchListener
      >
        <ToggleButtonGroup
          size="small"
          value={props.value}
          exclusive
          onChange={(e, v) => {
            // if (!loading && !!v) {
            //   props.onChange(v);
            //   runAsync(v);
            // }
            props.onChange(v);
          }}
          aria-label="text alignment"
          sx={{
            ".MuiToggleButton-root": {
              padding: "3px",
            },
          }}
        >
          <ToggleButton value={ListViewType.List} aria-label="list">
            <TableRowsRoundedIcon />
          </ToggleButton>

          <ToggleButton value={ListViewType.Table} aria-label="table">
            <ViewHeadlineIcon />
          </ToggleButton>
        </ToggleButtonGroup>
      </Tooltip>
    </ClickAwayListener>
  );
};
export default ViewType;
